// extracted by mini-css-extract-plugin
export default {"wrapper":"Table_wrapper__3w3f4","table":"Table_table__Ekd8l","row":"Table_row__Qei9J","col":"Table_col__pDmbc","status":"Table_status__pjWnN"};